import {KarenLayers, Layers} from "./KarenLayers";
import {Karen} from "../Karen";
import {TimelineLite, TweenLite} from "gsap";
import {KarenSoundManager} from "../sound/KarenSoundManager";
import {KarenSoundConfig} from "../sound/KarenSoundConfig";

export class KarenReelExpandOverlayView extends PIXI.Container {
    private _reelsOverlay: PIXI.spine.Spine[] = [];
    private _overlay: PIXI.spine.Spine;

    constructor() {
        super();
        this.init();
        KarenLayers.getLayer(Layers.REEL_EXPAND_OVERLAY)?.addChild(this);
    }

    public expandReels(reelId: number): TimelineLite {
        let tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            this._reelsOverlay[reelId - 2].state.setAnimation(0, "reel_expand", false);
        });
        tl.add(TweenLite.to(this, 0.2, {}));
        return tl;
    }

    public skipSpineAnimation(): void {
        this._reelsOverlay.forEach((reelOverlay: PIXI.spine.Spine) => {
            let trackEntry: PIXI.spine.core.TrackEntry = reelOverlay.state.getCurrent(0);
            if (trackEntry) {
                trackEntry.trackTime = trackEntry.animation.duration;
            }
        });
    }

    private init() {
        this.position.set(300, 340);
        for (let reelID = 0; reelID < 4; reelID++) {
            let spineObj: PIXI.spine.Spine = new PIXI.spine.Spine(Karen.assetLoader.getSpineAsset("scatter_reel_expand"));
            // spineObj.state.setAnimation(0, "reel_expand", true);
            spineObj.position.set(reelID * 120, 0);
            this.addChild(spineObj);
            this._reelsOverlay.push(spineObj);
        }
    }
}
